import React from 'react';
import Card from '@material-ui/core/Card';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import './tasks-grid-item.scss';
import { connect } from 'react-redux';
import { completedRoutes } from '../../../common/constants';

function TasksGridItem(props) {
  const history = useHistory();
  const { task, regionsBySysname, userPlacesById } = props;
  const { cover, style, id: taskId, placeId } = task;

  const handleOpenTaskInfo = () => {
    history.push(completedRoutes.taskInfo(taskId), { taskId });
  };

  const backgroundStyle = !cover ? {} : {
    background: `url(${cover}) no-repeat center`,
    backgroundSize: 'cover',
  };

  const { fullCols } = props;
  const taskPlaceData = userPlacesById[placeId];

  return (
    <Grid item xs={12} sm={fullCols ? 12 : 6} md={fullCols ? 12 : props.md}>
      <Card className='task-container' role="button" tabIndex="0" onClick={handleOpenTaskInfo}>
        <div className={`img task-${style} ${!!cover ? 'cover' : ''}`} style={backgroundStyle}>
          <div className="task-data">
            <span className="company-name">
              {taskPlaceData.name}
            </span>
            <span className="city-name">
              {regionsBySysname[taskPlaceData.region].name}
            </span>
            <div className="title">
              {task.name}
            </div>
          </div>
          <span className="price rubble">
            {task.price}
          </span>
          <span className="task-info-link">
            Условия задания
          </span>
          {!!cover && <div className="blackout" />}
        </div>
      </Card>
    </Grid>
  );
}

TasksGridItem.defaultProps = {
  md: 4,
};

const mapStateToProps = (state) => ({
  regionsBySysname: state.regions.data,
  userPlacesById: state.places.userPlaces.byId,
});

export default connect(mapStateToProps)(TasksGridItem);
